var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"feedback-entrance"},[_c('NavBread',{attrs:{"navData":_vm.navData}}),_c('div',{class:'feedback-entrance-content ' + _vm.zoom()},[_c('FeedbackEntranceComponent')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }